import { LocationSuggestion } from '@griply/types';

import { FirebaseHttpsCallableFactory } from '../types/firebase-functions';

export type GetLocationSuggestionsPayload = {
  input: string;
  // client UUID v4; reused by the closing place-details call so Google bills one session
  sessionToken: string;
  languageCode?: string;
};

type GetLocationSuggestionsResult = { suggestions: LocationSuggestion[] };

export type GetLocationSuggestionsOptions<TFunctions> = {
  functions: TFunctions;
  httpsCallable: FirebaseHttpsCallableFactory<TFunctions>;
  payload: GetLocationSuggestionsPayload;
};

export const getLocationSuggestions = async <TFunctions>(
  options: GetLocationSuggestionsOptions<TFunctions>,
): Promise<LocationSuggestion[]> => {
  const { functions, httpsCallable, payload } = options;
  const callable = httpsCallable<
    GetLocationSuggestionsPayload,
    GetLocationSuggestionsResult
  >(functions, 'locations-autocomplete');

  const { data } = await callable(payload);

  return data.suggestions;
};
